<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>
        Adjustments
      </v-toolbar-title>
      <template v-slot:extension>
        <v-tabs v-model="tab">
          <v-tab>
            {{ $i18n.translate("Single") }}
          </v-tab>
          <v-tab>
            {{ $i18n.translate("Bulk") }}
          </v-tab>
          <v-tab v-if="isBulkAdjustmentFeatureEnabled">
            {{ $i18n.translate("Bulk Payout Summary") }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-card-text>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <SingleAdjustment />
        </v-tab-item>
        <v-tab-item>
          <BulkPayout v-if="isBulkAdjustmentFeatureEnabled" />
          <div v-else class="text-center pa-8">
            <p class="text-h6 grey--text">{{ $i18n.translate("Coming soon") }}</p>
          </div>
        </v-tab-item>
        <v-tab-item v-if="isBulkAdjustmentFeatureEnabled">
          <BulkPayoutBatches ref="bulkPayoutBatches" />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import BulkPayoutBatches from "./BulkPayoutBatches.vue";
import BulkPayout from "./BulkPayout.vue";
import SingleAdjustment from "./SingleAdjustment.vue";
import { isProduction } from "@/gapp-components/utils/environment";

export default {
  components: { SingleAdjustment, BulkPayout, BulkPayoutBatches },
  name: "Adjustments",
  metaInfo: {
    title: "Adjustments"
  },
  data: () => ({
    tab: null
  }),
  computed: {
    isBulkAdjustmentFeatureEnabled() {
      return !isProduction();
    }
  },
  watch: {
    tab(newValue) {
      if (newValue === 2) {
        this.$nextTick(() => {
          this.$refs.bulkPayoutBatches?.getData();
        });
      }
    }
  }
};
</script>
